import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Table, Row, Col } from 'react-bootstrap';

import Edit from "../../../assets/images/edit.png";
import Trash from "../../../assets/images/delete.svg";
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import { toast } from 'react-toastify';

import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import edit from "../../../assets/images/edit.png";
import XLSFILE from '../../../assets/FixedRates-Trucker.xlsx'
import * as XLSX from 'xlsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faPlus, faBoxArchive, faDownload, faUpload } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { STATIONGRID, TRUCKERADDEMAIL, TRUCKEREDITEMAIL, TRUCKERDELEMAIL, TRUCKERSAVERATE, TRUCKERRATELIST, GETOWNERCODE } from '../../../Utils/conts.js';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const TruckSchedule = ({ rowData }) => {
    const [isLoading, setIsLoading] = useState(true);
    const isMounted = useRef(false);
    const [ratechart, setRateChart] = useState([]);
    const [formData, setFormData] = useState({ days_of_week: [], travel_days: 0 });
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [boardPoint, setBoardPoint] = useState([]);
    const [offPoint, setOffPoint] = useState([]);

    const gridRefs = useRef({});
    const gridRef = useRef(null);
    const [gridData, setGridData] = useState([]);
    const [gridSelect, setGridSelect] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);

    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA,
                        pref: item.AWB_prefix
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchStationData = async () => {
        try {

            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const activeInnerData = res.data.response_data.Active;
                    const transformedData = activeInnerData ? activeInnerData.map(item => ({
                        // id: item.id,
                        value: item.station_code,
                        label: item.station_code,
                        // address: item.station_addresses,
                    })) : []; // For multiselect
                    setBoardPoint(transformedData); // For multiselect
                    setOffPoint(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData({});
        fetchOwnerCode();
        fetchStationData();
        // loadDetails(truckerParent.trucker_id);
        // loadGrid();
        isMounted.current = true;
    }, []);
    const [stations, setstations] = useState([]);
    const [selected, setSelected] = useState([]);
    const [time, setTime] = useState(0);

    // UPLOAD
    const currencies = [
        { value: "EUR", label: "EUR (€) - Euro" },
        { value: "USD", label: "USD ($) - US Dollar" },
        { value: "PHP", label: "PHP (₱) - Philippine Peso" },
        { value: "JPY", label: "JPY (¥) - Japanese Yen" },
        { value: "GBP", label: "GBP (£) - British Pound" },
        { value: "AUD", label: "AUD (A$) - Australian Dollar" },
        { value: "CHF", label: "CHF (Fr.) - Swiss Franc" },
        { value: "CAD", label: "CAD (C$) - Canadian Dollar" },
        { value: "MXN", label: "MXN ($) - Mexican Peso" },
        { value: "CNY", label: "CNY (¥) - Chinese Yuan" },
        { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar" },
        { value: "SEK", label: "SEK (kr) - Swedish Krona" },
        { value: "RUB", label: "RUB (₽) - Russian Ruble" },
        { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar" },
        { value: "NOK", label: "NOK (kr) - Norwegian Krone" },
        { value: "SGD", label: "SGD (S$) - Singapore Dollar" },
        { value: "TRY", label: "TRY (₺) - Turkish Lira" },
        { value: "KRW", label: "KRW (₩) - South Korean Won" },
        { value: "ZAR", label: "ZAR (R) - South African Rand" },
        { value: "BRL", label: "BRL (R$) - Brazilian Real" },
        { value: "INR", label: "INR (₹) - Indian Rupee" },
        { value: "SAR", label: "SAR (﷼) - Saudi Riyal" },
        { value: "DKK", label: "DKK (kr) - Danish Krone" },
        { value: "RON", label: "RON (lei) - Romanian Leu" },
        { value: "XAF", label: "XAF (Fr) - Central African CFA Franc" },
        { value: "XOF", label: "XOF (Fr) - West African CFA Franc" },
        { value: "DOP", label: "DOP (RD$) - Dominican Peso" },
        { value: "HTG", label: "HTG (G) - Haitian Gourde" },
        { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar" },
        { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar" },
        { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar" },
        { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder" },
        { value: "COP", label: "COP (COL$) - Colombian Peso" },
        { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights" },
        { value: "XBT", label: "XBT (₿) - Bitcoin" },
        { value: "WGH", label: "WGH - West German Hard Currency" }
    ];
    const [showModal, setShowModal] = useState(false);
    const [modalRadioValue, setModalRadioValue] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [modalContent, setModalContent] = useState('EUR');
    const [fileName, setFileName] = useState('');
    const handleModalClose = () => { setShowModal(false); setModalRadioValue('') };

    const handleConfirmation = (confirm) => {
        if (confirm) {
            setShowModal(false);
            window.location.href = '/ULDControl'
        } else {
            setShowModal(false);
        }
    }
    const handleFileChange = (event) => {
        console.log("🚀 ~ handleFileChange ~ event:", event)
        setSelectedFile(event.target.files[0]);

        const input = event.target;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            setFileName(file.name);
            setSelectedFile(file);

            // const reader = new FileReader();
            // reader.onload = (e) => {
            //     setFileData(e.target.result);
            // };
            // reader.readAsText(file); // Use readAsText to read the content of the file
        }
    };
    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a file first!");
            return;
        }

        if (selectedFile) {
            // console.log("🚀 ~ handleUpload ~ selectedFile:", selectedFile)

            try {
                const payload = { ...selectedFile, }
                const formData = new FormData();
                formData.append("fix_rate_file", selectedFile);
                formData.append("trucker_id", rowData.trucker_id);
                formData.append("currency", modalContent);
                console.log("🚀 ~ handleUpload ~ selectedFile:", selectedFile)
                console.log("🚀 ~ handleUpload ~ formData:", formData)

                const res = await withRFSToken.post('upload-fix-rate', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (res.data.response_code == 200) {
                    toast.success(res.data.response_msg);
                    setShowModal(false)
                    // reloadRates()
                    setFileName('');
                }

            } catch (error) {
                console.error("There was an error uploading the file!", error);
            } finally {
                // setUploading(false);
            }
        }
    };

    const handleDownloadClick = () => {
        const a = document.createElement('a');
        a.href = XLSFILE;
        a.download = 'FixedRates-Trucker.xlsx'; // Name for the downloaded file
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'board_point', type: 'string' },
                    { name: 'off_point', type: 'string' },
                    { name: 'truck_no', type: 'string' },
                    { name: 'days_of_week', type: 'string' },
                    { name: 'travel_days', type: 'string' },

                    { name: 'min', type: 'string' },
                    { name: 'departure_time', type: 'string' },
                    { name: 'arrival_time', type: 'string' },
                    { name: 'per_kg', type: 'string' },
                    { name: 'position_1st', type: 'string' },
                    { name: 'position_2nd', type: 'string' },
                    { name: 'position_3rd', type: 'string' },
                    { name: 'ftl', type: 'string' },
                    { name: 'start_date', type: 'string' },
                    { name: 'end_date', type: 'string' },
                    { name: 'handling_cost', type: 'string' }
                ],
                url: `${process.env.REACT_APP_RFS_URL}truck-schedule/list?trucker_id=${rowData.trucker_id}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                // localdata: gridData[activeTab],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Action', datafield: '', width: '5%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        return `<div class="grid_actions"><img class="door_edit ts_edit" src="${Edit}"/>`;
                    }
                },
                //{ text: 'Boardpoint', datafield: 'board_point', width: '8%', filtertype: 'textbox', },
                { text: 'Truck No', datafield: 'truck_no', width: '8%', filtertype: 'textbox', },
                { text: 'Boardpoint', datafield: 'board_point', width: '13%', filtertype: 'checkedlist', filteritems: stations, },
                { text: 'Offpoint', datafield: 'off_point', width: '13%', filtertype: 'checkedlist', filteritems: stations, },
                { text: 'Select Days', datafield: 'days_of_week', width: '13%', filtertype: 'checkedlist', filteritems: stations, },
                { text: 'Start Date', datafield: 'start_date', width: '13%', filtertype: 'checkedlist', },
                { text: 'End Date', datafield: 'end_date', width: '13%', filtertype: 'checkedlist', },
                // { text: 'Travel Days', datafield: 'travel_days', width: '13%', filtertype: 'checkedlist', },
                // { text: 'Via Station', datafield: 'via_station', width: '8%', filtertype: 'textbox', },
                // { text: 'Min', datafield: 'min', width: '8%', filtertype: 'textbox', },
                // { text: 'Per KG', datafield: 'per_kg', width: '8%', filtertype: 'textbox', },
                // { text: '1 Position', datafield: 'position_1st', width: '8%', filtertype: 'textbox', },
                // { text: '2 Position', datafield: 'position_2nd', width: '8%', filtertype: 'textbox', },
                // { text: '3 Position', datafield: 'position_3rd', width: '8%', filtertype: 'textbox', },
                // { text: 'FTL', datafield: 'ftl', width: '8%', filtertype: 'textbox', },
                // { text: 'Handling Cost (Per KG)', datafield: 'handling_cost', width: '15%', filtertype: 'textbox', },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 800,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // rendered: function () {
                //   const rows = window.$(gridRef.current).jqxGrid('getrows');
                //   (checkUlds).forEach(uldNumber => {
                //     rows.forEach((element, index) => {
                //       if (element.uld_number == uldNumber) {
                //         window.$(gridRef.current).jqxGrid('selectrow', index);
                //       }
                //     });
                //   });
                // }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('click', '.ts_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                const truckNo = rowData.truck_no;
                const [part1, part2] = truckNo.split("-");
                const trData = {
                    id: rowData.id,
                    truck_prefix: part1,
                    truck_n: part2,
                    board_point: rowData.board_point,
                    off_point: rowData.off_point,
                    days_of_week: Array.isArray(rowData.days_of_week)
                        ? rowData.days_of_week
                        : JSON.parse(rowData.days_of_week || '[]'),
                    start_date: rowData.start_date,
                    end_date: rowData.end_date,
                    departure_time: rowData.departure_time,
                    arrival_time: rowData.arrival_time,
                    travel_days: rowData.travel_days,
                }
                // console.log("🚀 ~ rowData:", trData)
                setSelected(rowData.days_of_week);
                setTime(rowData.travel_days);
                setFormData(trData)
                setShowModal(true);
            });

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.awbId;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.awbId === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.awbId === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.awbId;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.awbId !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (![0, 1, 3, 6, 7].includes(event.args.columnindex)) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    //   loadDetails(args.awbId);
                    // setSelectedRowData(args)
                }
            });
            // }
        }
    }, [gridData]);

    // const [selected, setSelected] = useState([]);

    const handleAddTS = () => {
        setShowModal(true);
        setFormData({ days_of_week: [], travel_days: 0 });
        setSelected([]);
        setTime(0);
    }
    const handleClick = (day) => {
        const currentSelected = Array.isArray(selected) ? selected : [];
        const currentDays = Array.isArray(formData.days_of_week) ? formData.days_of_week : [];

        const updatedSelected = currentSelected.includes(day)
            ? currentSelected.filter((d) => d !== day)
            : [...currentSelected, day];

        const updatedDays = currentDays.includes(day)
            ? currentDays.filter((d) => d !== day)
            : [...currentDays, day];

        setSelected(updatedSelected);
        setFormData({
            ...formData,
            days_of_week: updatedSelected,
        });
    };

    const handleTimeChange = (e) => {
        let input = Number(e.target.value);
        if (input <= 0) {
            input = 0;
        }
        setTime(input);
        const updateData = { ...formData, travel_days: input }
        setFormData(updateData);

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleAddTruck = async () => {
        const dta = { ...formData, truck_no: formData.truck_prefix + '-' + formData.truck_n, trucker_id: rowData.trucker_id }
        const { truck_prefix, truck_n, ...rest } = dta;

        try {

            const res = await withRFSToken.post('truck-schedule/add-update', rest);
            if (res.data.response_code === 200) {
                setShowModal(false)
                window.$(gridRef.current).jqxGrid("updatebounddata");
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    // Frequency function Section Start
    const [frequentBooking, setFrequentBooking] = useState('O');
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // const updatedData = { ...frequentBooking, [name]: value };
        const updatedData = e.target.value;
        setFrequentBooking(updatedData);
        setFormData({
            ...formData,
            trip_type: updatedData
        });
    };
    // frequency Function End

    const handleFormOnchange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    }


    return (
        <>
        {console.log('fd', formData)}
            <div className='pt-4'>
                <h4>Manage Schedule - {rowData.trucker_name}</h4>
                <p>Manage truck schedule of the trucking company</p>
            </div>
            <div >
                <Form.Group className='d-flex mb-3 rate_search' controlId="exampleForm.ControlInput1">
                    <div className=''><Button onClick={handleAddTS}><FontAwesomeIcon icon={faFileImport} /> Add</Button></div>
                    {/* <div className='ms-auto'><Button><FontAwesomeIcon icon={faUpload} /> Upload</Button></div> */}
                </Form.Group>
            </div>
            <div>
                {!isLoading && <div ref={gridRef} className="staion_grid" />}
            </div>
            <Modal show={showModal} centered onHide={handleModalClose} className='addfrom' >
                <Modal.Header closeButton>
                    <Modal.Title>Add Truck Schedule</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group as={Row} className="mb-2 align-items-end">
                        <Col sm="4" className='pe-0'>
                            <Form.Label>Truck No. <span>*</span></Form.Label>
                            <Select
                                options={getOwnerCodes}
                                onChange={(selected) => {
                                    setFormData(prev => ({ ...prev, truck_prefix: selected.value }));
                                }}
                                // placeholder="Truck"
                                className='autoslct_nonbrd'
                                name="truck_prefix"
                                value={getOwnerCodes.find(option => option.value === formData?.truck_prefix) || ''}
                            // isDisabled={!isEditable}
                            />
                        </Col>
                        <Col className='add_hifent'>
                            <Form.Label> <span></span></Form.Label>
                            <Form.Control
                                type="text"
                                name='truck_n'
                                maxLength='8'
                                // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                value={formData?.truck_n || ''}
                                onChange={handleChange}
                            // disabled={!isEditable}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>BoardPoint</Form.Label>
                        <Select
                            options={boardPoint}
                            placeholder="BoardPoint"
                            className='autoslct_nonbrd'
                            onChange={(selected) => {
                                // const selectedValues = selected ? selected.map(option => option.value) : [];
                                setFormData({ ...formData, board_point: selected.value });
                            }}
                            // isMulti
                            name="boardPoint"
                            value={boardPoint.find(value => value.value === formData.board_point)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>OffPoint</Form.Label>
                        <Select
                            options={offPoint}
                            placeholder="OffPoint"
                            className='autoslct_nonbrd'
                            onChange={(selected) => {
                                // const selectedValues = selected ? selected.map(option => option.value) : [];
                                setFormData({ ...formData, off_point: selected.value });
                            }}
                            // isMulti
                            name="offPoint"
                            value={offPoint.find(value => value.value === formData.off_point)}
                        />
                    </Form.Group>

                    <hr />





                    <>
                        <Form.Label>Select Weekdays</Form.Label>

                        <ul className='freq_week mb-3'>
                            <li className={selected?.includes(1) ? 'selected' : ''} onClick={() => handleClick(1)}>Mo</li>
                            <li className={selected?.includes(2) ? 'selected' : ''} onClick={() => handleClick(2)}>Tu</li>
                            <li className={selected?.includes(3) ? 'selected' : ''} onClick={() => handleClick(3)}>We</li>
                            <li className={selected?.includes(4) ? 'selected' : ''} onClick={() => handleClick(4)}>Th</li>
                            <li className={selected?.includes(5) ? 'selected' : ''} onClick={() => handleClick(5)}>Fr</li>
                            <li className={selected?.includes(6) ? 'selected' : ''} onClick={() => handleClick(6)}>Sa</li>
                            <li className={selected?.includes(7) ? 'selected' : ''} onClick={() => handleClick(7)}>Su</li>
                        </ul>

                        <Form.Group as={Row} className='mb-2'>
                            <Form.Label>Bookingtruck Start & End Date </Form.Label>
                            <Col sm="6">
                                <Form.Control type="date" name='start_date' value={formData.start_date} onChange={handleFormOnchange} />
                            </Col>

                            <Col sm="6">
                                <Form.Control type="date" name='end_date' value={formData.end_date} onChange={handleFormOnchange} />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className='mb-2'>

                            <Col sm="6">
                                <Form.Label>Departure Time</Form.Label>
                                <Form.Control type="time" name='departure_time' value={formData.departure_time} onChange={handleFormOnchange} />
                            </Col>
                            <Col sm="6">
                                <Form.Label>Arrival Time</Form.Label>
                                <Form.Control type="time" name='arrival_time' value={formData.arrival_time} onChange={handleFormOnchange} />
                            </Col>
                            <Col sm="6">
                                <Form.Label>Travel Days</Form.Label>
                                <Form.Control
                                    type="number"
                                    name='travel_time'
                                    value={time}
                                    onChange={handleTimeChange}
                                    maxLength={5} // Limit length to 5 characters (HH:MM)
                                    placeholder='0'
                                />

                            </Col>

                        </Form.Group>

                        {/* <Form.Group as={Row} >
                                                                               
                                                                                <Col sm="6">
                                                                                <Form.Label>Arival Date</Form.Label>
                                                                                    <Form.Control type="date" name='arrival_date' value={formData.arrival_date} onChange={handleFormOnchange} />
                                                                                </Col>
                                                                                <Col sm="6">
                                                                                <Form.Label>Arival Time</Form.Label>
                                                                                    <Form.Control type="time" name='arrival_time' value={formData.arrival_time} onChange={handleFormOnchange} />
                                                                                </Col>
                                                                            </Form.Group> */}
                    </>




                    {/* <Form.Group className="mb-2">
                        <Form.Label>Select Weekdays</Form.Label>

                        <ul className='freq_week mb-3'>
                            <li className={selected.includes(1) ? 'selected' : ''} onClick={() => handleClick(1)}>Mo</li>
                            <li className={selected.includes(2) ? 'selected' : ''} onClick={() => handleClick(2)}>Tu</li>
                            <li className={selected.includes(3) ? 'selected' : ''} onClick={() => handleClick(3)}>We</li>
                            <li className={selected.includes(4) ? 'selected' : ''} onClick={() => handleClick(4)}>Th</li>
                            <li className={selected.includes(5) ? 'selected' : ''} onClick={() => handleClick(5)}>Fr</li>
                            <li className={selected.includes(6) ? 'selected' : ''} onClick={() => handleClick(6)}>Sa</li>
                            <li className={selected.includes(0) ? 'selected' : ''} onClick={() => handleClick(0)}>Su</li>
                        </ul>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Departure Date/Time</Form.Label>
                        <Form.Control
                            type="datetime-local"
                            name="departure_date_time"
                            onChange={(event) => {
                                const startDate = event.target.value;
                                setFormData({ ...formData, departure_date_time: startDate });
                            }}
                            value={formData.departure_date_time}
                        // placeholder="Truck Date"
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Arrival Date/Time</Form.Label>
                        <Form.Control
                            type="datetime-local"
                            name="arrival_date_time"
                            onChange={(event) => {
                                const startDate = event.target.value;
                                setFormData({ ...formData, arrival_date_time: startDate });
                            }}
                            value={formData.arrival_date_time}
                        // placeholder="Truck Date"
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Travel Days</Form.Label>
                        <Form.Control
                            type="number"
                            name='travel_time'
                            value={formData.travel_days || 0}
                            onChange={handleTimeChange}
                            maxLength={5} // Limit length to 5 characters (HH:MM)
                            placeholder='0'
                        />
                    </Form.Group> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={handleModalClose}>Cancel</Button>
                        <Button variant="primary" onClick={handleAddTruck}>{formData.id ? 'Update' : 'Add'} Truck</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default TruckSchedule